import React, { createContext, useContext, useState } from 'react';

import ManagerChainDrawer from 'features/org-view/manager-chain-drawer';

/**
 * Mounts the manager-chain drawer once, near the root, and hands every call site a way to open it:
 *
 *   const { showManagerChain } = useManagerChain();
 *   showManagerChain('someone@tll.aero');
 *
 * Same shape as confirmation-modal.ctx / print-intent-modal.ctx, minus the promise — this panel is
 * informational, so nothing waits on a result. Only whitelisted users can read the data behind it
 * (the backend enforces that), so call sites should still gate the affordance on
 * `isOrgViewWhitelisted` rather than offering a button that would 403.
 */
const ManagerChainContext = createContext({});

const ManagerChainProvider = ({ children }) => {
  const [email, setEmail] = useState(null);

  const showManagerChain = (subjectEmail) => setEmail(subjectEmail || null);
  const closeManagerChain = () => setEmail(null);

  const value = { showManagerChain, closeManagerChain };

  return (
    <ManagerChainContext.Provider value={value}>
      {children}
      <ManagerChainDrawer email={email} onClose={closeManagerChain} />
    </ManagerChainContext.Provider>
  );
};

export default ManagerChainProvider;

export const useManagerChain = () => useContext(ManagerChainContext);
